// Conversión HEIC/HEIF -> JPEG en el cliente.
//
// Las fotos de iPhone vienen en HEIC y los navegadores no-Safari no saben
// renderizarlas en <img> (la imagen aparece "rota" en la galería y el visor
// de adjuntos). En vez de rechazarlas o convertirlas en el backend, las
// convertimos a JPEG al momento de adjuntar: lo que viaja al servidor ya es
// un JPEG y se ve bien en cualquier navegador (preview, galería y descarga).

const HEIC_EXTENSIONS = ['heic', 'heif']
const HEIC_MIMES = ['image/heic', 'image/heif', 'image/heic-sequence', 'image/heif-sequence']

export const isHeicFile = (file) => {
    if (!file) return false
    if (HEIC_MIMES.includes((file.type || '').toLowerCase())) return true
    const ext = (file.name?.split('.').pop() || '').toLowerCase()
    return HEIC_EXTENSIONS.includes(ext)
}

export const convertHeicToJpeg = async (file) => {
    if (!isHeicFile(file)) return file
    // Import dinámico: heic2any trae libheif compilado (~1MB) y solo se
    // descarga la primera vez que alguien adjunta un HEIC.
    const { default: heic2any } = await import('heic2any')
    const converted = await heic2any({ blob: file, toType: 'image/jpeg', quality: 0.9 })
    // heic2any devuelve array si el HEIC trae varias imágenes (burst/live);
    // nos quedamos con la primera.
    const blob = Array.isArray(converted) ? converted[0] : converted
    const name = (file.name || 'imagen.heic').replace(/\.[^.]+$/, '') + '.jpg'
    // Se preserva lastModified porque AddTicket/TicketQuestion lo usan como
    // clave para quitar archivos de la lista (removeFileState).
    return new File([blob], name, { type: 'image/jpeg', lastModified: file.lastModified })
}
